import { createSelector } from "@ngrx/store";

import { AppState } from "../store";
import { ProductFeatureState } from "./product-feature.reducers";

const feature = (state: AppState) => state.productFeature;

export const productFeaturesSelector = createSelector(
  feature,
  (state: ProductFeatureState) => state.productFeatures
);

export const productFeaturesErrorSelector = createSelector(
  feature,
  (state: ProductFeatureState) => state.loadProductFeaturesError
);
